import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCloggedPoresGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M28.267 17.461c0-.055.018-.11.018-.176A4.287 4.287 0 0 0 24 13a4.293 4.293 0 0 0-4.285 4.285c0 .056.018.111.018.176a9.327 9.327 0 0 0-5.008 7.68H8v1.16h6.725c.306 4.86 4.34 8.728 9.275 8.728 4.934 0 8.979-3.868 9.275-8.728H40v-1.16h-6.725a9.307 9.307 0 0 0-5.008-7.68ZM24 14.16a3.118 3.118 0 0 1 3.098 2.792A9.293 9.293 0 0 0 24 16.413a9.293 9.293 0 0 0-3.098.538A3.118 3.118 0 0 1 24 14.16Zm2.987 3.989c-.38 1.308-1.568 2.272-2.996 2.272-1.429 0-2.616-.964-2.996-2.272a8.05 8.05 0 0 1 2.996-.575 8.05 8.05 0 0 1 2.996.575Zm-7.04.51c.575 1.688 2.16 2.922 4.044 2.922 1.883 0 3.469-1.225 4.044-2.922a8.14 8.14 0 0 1 4.072 6.483H15.875a8.17 8.17 0 0 1 4.072-6.483ZM24 33.87c-4.294 0-7.82-3.349-8.116-7.57h16.232c-.306 4.221-3.822 7.57-8.116 7.57Z",
    fill: "currentColor"
  }));
}

export { SvgCloggedPoresGlyph as default };
